import React from 'react';
import {
  Grid
} from '@mui/material';
import GenericModal from '../GenericModal';
import { DrillDownData } from '../../types/productDrillDown';
import DrillDownProductInfo from '../DrillDown/ProductInfo';
import DrillDownEvolutionChart from '../DrillDown/EvolutionChart';
import DrillDownCfopChart from '../DrillDown/CfopChart';
import DrillDownDetailedTransactions from '../DrillDown/DetailedTransactions';
import DrillDownSummaryTable from '../DrillDown/SummaryTable';
import DrillDownPartnersSection from '../DrillDown/PartnersSection';
import { formatMonthYear } from '../DrillDown/formatters';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface ProductDrillDownModalProps {
  open: boolean;
  onClose: () => void;
  data: DrillDownData | null;
  loading: boolean;
  productName: string;
}

const ProductDrillDownModal: React.FC<ProductDrillDownModalProps> = ({
  open,
  onClose,
  data,
  loading,
  productName
}) => {
  const renderContent = () => {
    if (!data || !data.produto) return null;

    const { produto, transacoes_por_mes, top_cfops, transacoes_detalhadas, resumo_cfop_aliquota, parceiros_comerciais } = data;

    const creditData = {
      id: 'Créditos ICMS',
      data: (transacoes_por_mes || []).map(item => ({
        x: formatMonthYear(item.mes, item.ano),
        y: item.credito_icms,
        transacoes: item.total_transacoes_credito || 0
      }))
    };

    const debitData = {
      id: 'Débitos ICMS',
      data: (transacoes_por_mes || []).map(item => ({
        x: formatMonthYear(item.mes, item.ano),
        y: item.debito_icms,
        transacoes: item.total_transacoes_debito || 0
      }))
    };

    const lineData = [
      debitData,
      creditData
    ];

    return (
      <Grid container spacing={3}>
        <DrillDownProductInfo produto={produto} />
        <DrillDownEvolutionChart lineData={lineData} />
        <DrillDownCfopChart top_cfops={top_cfops || []} />
        <DrillDownSummaryTable resumo_cfop_aliquota={resumo_cfop_aliquota || []} />
        <DrillDownPartnersSection parceiros_comerciais={parceiros_comerciais || { fornecedores: [], clientes: [] }} />
        <DrillDownDetailedTransactions transacoes_detalhadas={transacoes_detalhadas || []} />
      </Grid>
    );
  };

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title="Detalhes do Produto"
      loading={false}
      showBreadcrumb={true}
      breadcrumbItems={[{ label: productName }]}
    >
      {loading ? (
        <ProductDrillDownSkeleton />
      ) : (
        renderContent()
      )}
    </GenericModal>
  );
};

export default ProductDrillDownModal;
